import { lazy } from "react";
import Loadable from "app/components/Loadable";

const OrgPropertyListingForm = Loadable(lazy(() => import("./OrgPropertyListingForm")));

const organizationRoute = [{ path: "/organization", element: <OrgPropertyListingForm /> }];
export default organizationRoute;


